import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy,
    ElementRef,
    Output,
    EventEmitter
  } from '@angular/core';
  import { formatLabel } from './common/label.helper';
  import { BarOrientation } from './common/types/bar-orientation.enum';
  
  @Component({
    selector: 'g[ngx-charts-bar-label-custom]',
    template: `
      <svg:rect *ngIf="!labelIn || (barWidth > -25 && barWidth < 25)"  [attr.x]="x - centerX" [attr.y]="y - centerY" [attr.text-anchor]="textAnchor" width="25" height="15" style="fill:#ffffff;stroke-width:0;stroke:#ffffff" />
      <svg:text
        class="textDataLabel"
        [class.white_text]="labelIn && (barWidth < -25 || barWidth > 25)"
        [class.labelHidden]="hideLabel"
        alignment-baseline="middle"
        [attr.text-anchor]="textAnchor"
        [attr.transform]="transform"
        [attr.x]="x"
        [attr.y]="y"
      >
        {{ formatedValue }}
      </svg:text>
    `,
    styleUrls: ['./scss/bar-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
  export class BarLabelComponent implements OnChanges {
    @Input() value;
    @Input() valueFormatting: any;
    @Input() barX;
    @Input() barY;
    @Input() barWidth;
    @Input() barHeight;
    @Input() labelIn:boolean = true;
    @Input() orientation: BarOrientation;
    @Input() noBarWhenZero:boolean = true;
    @Output() dimensionsChanged: EventEmitter<any> = new EventEmitter();
  
    element: any;
    x: number;
    y: number;

    // added to bg rect
    centerX:number = 0;
    centerY:number = 8;
    // -----------
    horizontalPadding: number = 2;
    verticalPadding: number = 5;
    formatedValue: string;
    transform: string;
    textAnchor: string;
    hideLabel: boolean = false;

    constructor(element: ElementRef) {
      this.element = element.nativeElement;
      
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      this.update();
    }
  
    getSize(): any {
      const h = this.element.getBoundingClientRect().height;
      const w = this.element.getBoundingClientRect().width;
      return { height: h, width: w, negative: this.value < 0 };
    }
  
    ngAfterViewInit() {
      this.dimensionsChanged.emit(this.getSize());
    }
  
    update(): void {
      if(this.barWidth == 0 && this.noBarWhenZero){
        this.hideLabel = true;
      }
      if (this.valueFormatting) {
        this.formatedValue = this.valueFormatting(this.value);
      } else {
        this.formatedValue = formatLabel(this.value);
      }
  
      if (this.orientation === 'horizontal') {
        this.x = this.barX + this.barWidth;
        // if the value is negative then it's on the left of the x0.
        // we need to put the data label in front of the bar
        if (this.value < 0) {
          if(this.labelIn && (this.barWidth <= -25)){
            this.x = this.x - this.horizontalPadding + 15;
            this.textAnchor = 'start';
          }else{
            this.x = this.x - this.horizontalPadding;
            this.textAnchor = 'end';
          }
          this.centerX = 23; //added to bg rect
        } else {
          if(this.labelIn && (this.barWidth >= 25)){
            this.x = this.x + this.horizontalPadding - 15;
            this.textAnchor = 'end';
          }else{
            this.x = this.x + this.horizontalPadding;
            this.textAnchor = 'start';
          }
        }
        this.y = this.barY + this.barHeight / 2;
      } else {
        // orientation must be "vertical"
        this.x = this.barX + this.barWidth / 2;
        this.y = this.barY + this.barHeight;
  
        if (this.value < 0) {
          this.y = this.y + this.verticalPadding;
          this.textAnchor = 'end';
          this.centerX = 23; //added to bg rect
        } else {
          this.y = this.y - this.verticalPadding;
          this.textAnchor = 'start';
        }
        this.transform = `rotate(-45, ${this.x} , ${this.y})`;
      }
    }
  }